import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';
import { Link } from 'react-router-dom';

import { SelectFilter } from '@/components/ui/search-filter';
import { Route } from '@/constants';
import { formatCurrencyInBDT } from '@/utils';

import { SectionTitle } from '../../../../ui';
import { CustomSkelton } from '../../../../ui/custom.skelton';
import {
    DashboardOverviewPeriod,
    useDashboard,
} from '../../dashboard.provider';

const overviewPeriodOptions: Array<{
    label: string;
    value: DashboardOverviewPeriod;
}> = [
    { label: 'Today', value: 'today' },
    { label: 'This month', value: 'this_month' },
    { label: 'All time', value: 'all_time' },
];

export const Stats = () => {
    const {
        statsData,
        statsLoading,
        statsFetching,
        overviewPeriod,
        setOverviewPeriod,
    } = useDashboard();

    const periodFilter = (
        <div className="flex justify-between">
            <div>
                <SectionTitle>Overview</SectionTitle>
            </div>
            <SelectFilter
                // title="Overview period"
                options={overviewPeriodOptions}
                value={overviewPeriod}
                onChange={(value) =>
                    setOverviewPeriod(value as DashboardOverviewPeriod)
                }
            />
        </div>
    );

    if (statsLoading || statsFetching) {
        return (
            <div className="space-y-4">
                {periodFilter}
                <CustomSkelton count={8} type="card" />
            </div>
        );
    } else if (statsData && !statsLoading && !statsFetching) {
        return (
            <div className="space-y-4">
                {periodFilter}
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
                    <Link to={Route.REPORTS_PROFIT_AND_LOSS}>
                        <Card className="cursor-pointer bg-emerald-200 duration-150 hover:scale-105 hover:bg-emerald-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Income
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {formatCurrencyInBDT(
                                        statsData.total_income,
                                    )}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-green-500">*/}
                                {/*        <BsArrowUpRight size={12} />*/}
                                {/*        20.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>

                    <Link to={Route.EXPENSES}>
                        <Card className="cursor-pointer bg-rose-200 duration-150 hover:scale-105 hover:bg-rose-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Expense
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {formatCurrencyInBDT(
                                        statsData.total_expense,
                                    )}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-green-500">*/}
                                {/*        <BsArrowUpRight size={12} />*/}
                                {/*        20.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>

                    <Link to={Route.SALES}>
                        <Card className="cursor-pointer bg-sky-200 duration-150 hover:scale-105 hover:bg-sky-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Order
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_orders}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-red-500">*/}
                                {/*        <BsArrowDownRight size={12} />*/}
                                {/*        10.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>
                    <Link to={Route.PRODUCTS}>
                        <Card className="cursor-pointer bg-violet-200 duration-150 hover:scale-105 hover:bg-violet-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Products
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_products}
                                </div>
                            </CardContent>
                        </Card>
                    </Link>
                    <Link to={Route.STOCK_LOW_PRODUCTS}>
                        <Card className="cursor-pointer bg-amber-200 duration-150 hover:scale-105 hover:bg-amber-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Low Stock
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_low_stock_products}
                                </div>
                            </CardContent>
                        </Card>
                    </Link>
                    <Link to={Route.STOCK_EXPIRED_PRODUCTS}>
                        <Card className="cursor-pointer bg-orange-200 duration-150 hover:scale-105 hover:bg-orange-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Expire Items
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_expired_products}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-green-500">*/}
                                {/*        <BsArrowUpRight size={12} />*/}
                                {/*        20.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>
                    <Link to={Route.CUSTOMERS}>
                        <Card className="cursor-pointer bg-cyan-200 duration-150 hover:scale-105 hover:bg-cyan-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Customer
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_customers}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-green-500">*/}
                                {/*        <BsArrowUpRight size={12} />*/}
                                {/*        20.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>
                    <Link to={Route.SUPPLIERS}>
                        <Card className="cursor-pointer bg-pink-200 duration-150 hover:scale-105 hover:bg-pink-300">
                            <CardHeader className="relative flex flex-row items-center justify-between space-y-0 pb-2">
                                <CardTitle className="text-sm font-medium capitalize">
                                    Total Supplier
                                </CardTitle>
                                <span className="absolute right-4 top-4 text-[28px] font-semibold opacity-25">
                                    ৳
                                </span>
                            </CardHeader>
                            <CardContent>
                                <div className="text-2xl font-bold">
                                    {statsData.total_suppliers}
                                </div>
                                {/*<p className="flex items-center text-xs text-muted-foreground">*/}
                                {/*    <span className="mr-1 flex items-center text-green-500">*/}
                                {/*        <BsArrowUpRight size={12} />*/}
                                {/*        20.1%*/}
                                {/*    </span>*/}
                                {/*    from last month*/}
                                {/*</p>*/}
                            </CardContent>
                        </Card>
                    </Link>
                </div>
            </div>
        );
    } else {
        return 'Failed to find data!';
    }
};
